import { gql } from "@apollo/client"

export const LikeTeamActionFragment = gql`
    fragment LikeTeamAction_team on RecruitingTeamType {
        id
        uuid
        isLiked
    }
`
